import {Menubar} from "primereact/menubar";

export default function NsMenuView({
                                       user,
                                       translate,
                                       isRuoloAdmin,
                                       isRuoloSuperAdmin,
                                       itemRendererMenubar,
                                       start,
                                       end,
                                       goTo,
                                       showCarbonFootprint,
                                       showEsrs,
                                   }) {

    return (
        <div className={"ns-fixed"}>
            <Menubar
                model={user ? [
                    {
                        label: translate('Dashboard'),
                        icon: 'pi pi-home',
                        command: () => {
                            goTo('/home-container');
                        }
                    },
                    isRuoloAdmin() && {
                        label: translate('Configura'),
                        icon: 'fas fa-cogs',
                        items: [
                            {
                                label: translate('Utenti'),
                                icon: 'fas fa-user',
                                template: itemRendererMenubar,
                                command: () => {
                                    goTo('/conf-utenti');
                                }
                            },
                            {
                                label: translate('Gruppi e Permessi'),
                                icon: 'fas fa-users',
                                template: itemRendererMenubar,
                                command: () => {
                                    goTo('/conf-gruppi-utente');
                                }
                            },
                            {
                                separator: true
                            },
                            {
                                label: translate('Struttura organizzazione'),
                                icon: 'fas fa-tags',
                                template: itemRendererMenubar,
                                command: () => {
                                    goTo('/conf-classi-imp-exp');
                                }
                            },
                            {
                                separator: true
                            },
                            {
                                label: translate('Struttura KPI'),
                                icon: 'fas fa-tag',
                                template: itemRendererMenubar,
                                command: () => {
                                    goTo('/conf-classi-macrocategorie');
                                }
                            },
                            {
                                label: translate('Stati KPI'),
                                icon: 'fas fa-stream',
                                template: itemRendererMenubar,
                                command: () => {
                                    goTo('/conf-stati_kpi');
                                }
                            },
                            showEsrs && {
                                label: translate('Topics'),
                                icon: 'fas fa-list',
                                template: itemRendererMenubar,
                                command: () => {
                                    goTo('/conf-topics');
                                }
                            },
                            {
                                label: translate('KPI'),
                                icon: 'fas fa-table',
                                template: itemRendererMenubar,
                                command: () => {
                                    goTo('/conf-kpi');
                                }
                            },
                            isRuoloSuperAdmin() && {
                                separator: true
                            },
                            isRuoloSuperAdmin() && {
                                label: translate('Impostazioni'),
                                icon: 'fas fa-sliders',
                                template: itemRendererMenubar,
                                command: () => {
                                    goTo('/conf-parametri');
                                }
                            },
                        ].filter(b => b)
                    },
                    {
                        label: translate('Indicatori'),
                        icon: 'fas fa-table',
                        command: () => {
                            goTo('/list-kpi');
                        }
                    },
                    showCarbonFootprint && {
                        label: translate('Carbon Footprint'),
                        icon: 'fas fa-leaf',
                        command: () => {
                            goTo('/list-kpi-carbon');
                        }
                    },
                    {
                        label: translate('Esportazione'),
                        icon: 'fas fa-file-export',
                        command: () => {
                            goTo('/export-kpi');
                        }
                    },
                ].filter(b => b) : []}
                start={start}
                end={end}
            />
        </div>
    );
}
